<template>
    <div class="session__summary_print_table">
        <component-table
            :labels="tableLabels"
            :checkbox="false"
            :items="items"
            :component-table-item="SessionSummaryPrintTableItem"
            :empty-state-active="false"
        />
    </div>
</template>

<script>
import SessionSummaryPrintTableItem from '@/components/ebs/sessions/summary/SessionSummaryPrintTableItem'
import ComponentTable from '@/components/default/shared/ComponentTable'
import { toKebabCase, toString } from '@/functions'

export default {
  name: 'session-summary-print-table',
  components: {
    ComponentTable
  },
  data () {
    return {
      SessionSummaryPrintTableItem
    }
  },
  computed: {
    routeQuery () {
      return this.$route.query
    },
    routeQueryIncludeEmailInPrint () {
      return this.routeQuery.includeEmailInPrint
    },
    routeQueryAdditionalColumn () {
      return this.routeQuery.includeAdditionalColumnInPrint
    },
    routeQueryAdditionalColumnName () {
      return this.routeQuery.additionalColumnName
    },
    tableLabels () {
      let labelsArr = []

      labelsArr.push({
        key: 'name',
        title: 'Name',
        type: 'string',
        sortable: false
      })

      if (this.routeQueryIncludeEmailInPrint) {
        labelsArr.push({
          key: 'email',
          title: 'Email',
          type: 'string',
          sortable: false
        })
      }

      labelsArr.push({
        key: 'attendance',
        title: 'Attendance',
        type: 'string',
        sortable: false
      })

      labelsArr.push({
        key: 'assessment',
        title: 'Assessment',
        type: 'string',
        sortable: false
      })

      if (this.routeQueryAdditionalColumn) {
        labelsArr.push({
          key: toKebabCase(this.routeQueryAdditionalColumnName),
          title: toString(this.routeQueryAdditionalColumnName),
          type: 'string',
          sortable: false
        })
      }

      return labelsArr
    }
  },
  props: {
    items: {
      type: [Array, Object]
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionsummaryprinttable";
</style>
